import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { Benefits } from './components/Benefits';
import { BonusSection } from './components/BonusSection';
import { ConsciousnessMessage } from './components/ConsciousnessMessage';
import { Testimonials } from './components/Testimonials';
import { VoiceTestimonial } from './components/VoiceTestimonial';
import { Footer } from './components/Footer';
export function App() {
  return <main className="w-full min-h-screen bg-warm-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPoints data-id="element-2" />
      <Benefits data-id="element-3" />
      <BonusSection data-id="element-4" />
      <ConsciousnessMessage data-id="element-5" />
      <Testimonials data-id="element-6" />
      <VoiceTestimonial data-id="element-7" />
      <Footer data-id="element-8" />
    </main>;
}